import { AttachmentType, SimulatorResultItem } from '@sdir/httpclient/lib/clients/aps/application';
import { routes } from '../constants/routes';
import { QualificationType } from '../types';

export type QualificationBehaviour = {
  canAddInfo: boolean;
  canConfirm?: boolean;
  editRoute?: string;
  attachmentType?: AttachmentType;
};

export const getBehaviourForQualification = (
  qualification: SimulatorResultItem,
  isExternalUser?: boolean
): QualificationBehaviour => {
  switch (qualification.type) {
    case QualificationType.Course:
      return {
        canAddInfo: true,
        editRoute: routes.application.addCourse,
        attachmentType: AttachmentType.Course,
      };
    case QualificationType.Education:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Education,
        editRoute: routes.application.addCourse,
      };
    case QualificationType.SeagoingTime:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.SeagoingTime,
        editRoute: isExternalUser
          ? routes.application.addSeagoingAttachment
          : routes.application.addSeagoing,
      };
    case QualificationType.Assessment:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Assessment,
        editRoute: routes.application.addAssessment,
      };
    case QualificationType.AdditionalCompetence:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.AdditionalCompetence,
        editRoute: routes.application.addAdditionalCompetence,
      };
    case QualificationType.Health:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.HealthCheck,
        editRoute: routes.application.addHealthCheck,
      };
    case QualificationType.ProfilePicture:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Photo,
        editRoute: routes.application.addPhoto,
      };
    case QualificationType.Signature:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Signature,
        editRoute: routes.application.addSignature,
      };
    case QualificationType.ApplicationServiceOther:
      if (qualification?.uri === 'https://www.sdir.no/SDIR_ApplicationService/ForeignId') {
        return {
          canAddInfo: true,
          attachmentType: AttachmentType.ForeignId,
          editRoute: routes.application.addForeignId,
        };
      }
      return { canAddInfo: false };
    case QualificationType.Certificate:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Certificate,
        editRoute: routes.application.addCertificate,
      };
    case QualificationType.IdCard:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.NorwegianPassportOrId,
        editRoute: routes.application.addNorwegianId,
      };
    case QualificationType.Declaration:
      return {
        canAddInfo: false,
        canConfirm: true,
      };
    case QualificationType.Confirmation:
      return {
        canAddInfo: true,
        attachmentType: AttachmentType.Confirmation,
        editRoute: routes.application.addConfirmation,
      };
    default:
      return { canAddInfo: false };
  }
};
